import React from 'react';
import {Table, Text} from '@gravity-ui/uikit';
import {formatCurrency} from '../../../../shared';
import {OrderDetailModel} from '../../model';
import styles from './OrderAmountDistribution.module.scss';

interface OrderAmountDistributionProps {
  orderData: OrderDetailModel;
}

interface DistributionItem {
  id: string;
  category: string;
  intended: number;
  actual: number;
}

export const OrderAmountDistribution = ({orderData}: OrderAmountDistributionProps) => {
  const distributionData: DistributionItem[] = [
    {
      id: 'paymentSystemFee',
      category: 'Комиссия платежной системы',
      intended: orderData.intendedAmountSummary.paymentSystemFee,
      actual: orderData.actualAmountSummary.paymentSystemFee,
    },
    {
      id: 'oneTimeAppeal',
      category: 'Разовые пожертвования на сбор',
      intended: orderData.intendedAmountSummary.oneTimeAppeal,
      actual: orderData.actualAmountSummary.oneTimeAppeal,
    },
    {
      id: 'oneTimeProject',
      category: 'Разовые пожертвования на проект',
      intended: orderData.intendedAmountSummary.oneTimeProject,
      actual: orderData.actualAmountSummary.oneTimeProject,
    },
    {
      id: 'projectSubscription',
      category: 'Подписка на проект',
      intended: orderData.intendedAmountSummary.projectSubscription,
      actual: orderData.actualAmountSummary.projectSubscription,
    },
    {
      id: 'projectSubscriptionCharge',
      category: 'Списание подписки на проект',
      intended: orderData.intendedAmountSummary.projectSubscriptionCharge,
      actual: orderData.actualAmountSummary.projectSubscriptionCharge,
    },
    {
      id: 'projectServiceFee',
      category: 'Комиссия (сервисный сбор) проекта',
      intended: orderData.intendedAmountSummary.projectServiceFee,
      actual: orderData.actualAmountSummary.projectServiceFee,
    },
  ];

  const distributionColumns = [
    {
      id: 'category',
      name: 'Распределение средств',
      width: '50%',
      template: (item: DistributionItem) => <Text variant="body-1">{item.category}</Text>,
    },
    {
      id: 'intended',
      name: 'Планируемое',
      width: '25%',
      template: (item: DistributionItem) => <Text variant="body-1">{formatCurrency(item.intended)}</Text>,
    },
    {
      id: 'actual',
      name: 'Фактическое',
      width: '25%',
      template: (item: DistributionItem) => <Text variant="body-1">{formatCurrency(item.actual)}</Text>,
    },
  ];

  return (
    <div className={styles.distributionTable}>
      <Table data={distributionData} columns={distributionColumns} edgePadding={false} width="max" />
    </div>
  );
};
